import { b as __assign } from '../../../../tslib.es6-14c74580.js';
import '../../enums/GameSpecificTypes.js';
import '../../enums/MaxPayoutDataTypes.js';
import '../../enums/Chat.js';
import '../../enums/GameModes.js';
import '../../enums/IconTypes.js';
import '../../enums/BetStatus.js';
import '../../enums/PopupTypes.js';
import '../../enums/ApiVersion.js';
import '../../enums/RoundStatus.js';
import '../../enums/FreeBetsStatus.js';
import '../../enums/SocketEvents.js';
import '../../enums/TranslationKeys.js';
import '../../enums/TimeoutMaxValue.js';
import '../../enums/ApiServiceTypes.js';
import '../../enums/EnvironmentTypes.js';
import '../../enums/DefaultQueryValues.js';
import '../../enums/FreeBetWinningType.js';
import '../../enums/DefaultQueryParams.js';
import '../../enums/BetHistoryFilterTypes.js';
import '../../enums/GameThemeTypes.js';
import { RequestStatus } from '../../enums/RequestStatus.js';
import '../../enums/FetchDefaultPaths.js';
import '../../enums/ResponseCodes.js';

var HttpResponse = /** @class */ (function () {
    function HttpResponse(initialState, status) {
        if (status === void 0) { status = RequestStatus.Pending; }
        this._initialState = initialState;
        this.data = initialState;
        this.status = status;
        this.error = [];
    }
    Object.defineProperty(HttpResponse.prototype, "isDone", {
        get: function () {
            return this.status === RequestStatus.Done;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpResponse.prototype, "isLoading", {
        get: function () {
            return this.status === RequestStatus.Pending;
        },
        enumerable: false,
        configurable: true
    });
    HttpResponse.prototype.fetching = function (resetData, customStatus) {
        if (resetData === void 0) { resetData = false; }
        if (resetData) {
            this.data = this._initialState;
        }
        this.status = customStatus || RequestStatus.Pending;
        return this.clone();
    };
    HttpResponse.prototype.failed = function (errorMessages) {
        this.error = errorMessages;
        this.status = RequestStatus.Error;
        return this.clone();
    };
    HttpResponse.prototype.fetched = function (data) {
        this.data = data;
        this.status = RequestStatus.Done;
        return this.clone();
    };
    HttpResponse.prototype.clone = function () {
        var self = __assign({}, this);
        Object.setPrototypeOf(self, HttpResponse.prototype);
        return self;
    };
    return HttpResponse;
}());

export { HttpResponse };
